<template>
    <div class="footer-container">
        <div class="footer-wrapper">
            <div class="footer-link_section">                
                <div class="footer_section" id="aboutUs">
                    <p class="title_section">Sobre MyInvestor</p>
                    <ul class="menu">
                        <li><a id="newClient" rel="noopener noreferrer" href="https://newapp.myinvestor.es/auth/signup/intro/?data_trigger=Footer_link_HazteCliente&data_traffic_origin=Landing_helloteca" target="_blank">Hazte cliente</a></li>
                        <li><a id="knowUs" rel="noopener noreferrer" href="https://myinvestor.es/conocenos/" target="_blank">Conócenos</a></li>
                        <li><a id="knowUs" rel="noopener noreferrer" href="https://myinvestor.es/trabaja-con-nosotros/" target="_blank">Trabaja con nosotros</a></li>
                        <li><a id="blog" rel="noopener noreferrer" href="https://myinvestor.es/blog/" target="_blank">Blog</a></li>
                        <li><a id="press" rel="noopener noreferrer" href="https://myinvestor.es/notas-de-prensa/" target="_blank">Sala de prensa</a></li>
                    </ul>
                </div>
                <div class="footer_section" id="legalTerm">
                    <p class="title_section">Términos legales</p>
                    <ul class="menu">
                        <li><a id="legal" rel="noopener noreferrer" href="https://myinvestor.es/legal/aviso-legal/" target="_blank">Aviso legal</a></li>
                        <li><a id="info" rel="noopener noreferrer" href="https://myinvestor.es/legal/informacion-legal/" target="_blank">Información legal</a></li>
                        <li><a id="corporateGovernment" rel="noopener noreferrer" href="https://myinvestor.es/legal/gobierno-corporativo/" target="_blank">Gobierno corporativo y Política de remuneraciones</a></li>
                        <li><a id="sac" rel="noopener noreferrer" href="https://myinvestor.es/legal/atencion-cliente/" target="_blank">Reclamaciones</a></li>
                        <li><a id="cookies" rel="noopener noreferrer" href="https://myinvestor.es/legal/politica-cookies/" target="_blank">Política de cookies</a></li>
                        <li><a id="complaints" rel="noopener noreferrer" href="https://cdn.myinvestor.es/public/legal/Canal_de_denuncias_de_MyInvestor_Banco_SA.pdf?_gl=1*1qxar05*_gcl_au*NTkzNjgxOTMwLjE3MjQ4MjkxNDA.*_ga*MTY5ODk1NzQyNS4xNzA2MDgzMDc1*_ga_E449DX4JV1*MTcyNDk0MTg5OC41LjEuMTcyNDk0Mzg4My4yNC4wLjA.*_ga_25S410CT5X*MTcyNDk0MTg5OC4yLjEuMTcyNDk0Mzg0Ny42MC4wLjA.*_ga_7DFYQRPKLN*MTcyNDk0MTg5OC4yLjEuMTcyNDk0Mzg0Ny42MC4wLjA." target="_blank">Canal de denuncias</a></li>
                    </ul>
                </div>
                <div class="footer_section" id="help">
                    <p class="title_section">Ayuda y contacto</p>
                    <ul class="menu">
                        <li><a id="about" rel="noopener noreferrer" href="https://myinvestor.es/ayuda/preguntas-frecuentes/" target="_blank">Preguntas frecuentes</a></li>
                    </ul>
                    <div class="phone-wrapper">
                        <span class="icon">
                            <svg height="1em" width="1em" viewBox="0 0 32 32" role="presentation" style="min-width: 1em; max-width: 1em; min-height: 1em; max-height: 1em;">
                                <path d="M30.667 23.227a4 4 0 0 0-3.464-4.031 15.48 15.48 0 0 1-3.448-.861 4.055 4.055 0 0 0-1.792-.232 3.976 3.976 0 0 0-2.425 1.14l-.96.96a19.786 19.786 0 0 1-6.111-6.119l.968-.968c.429-.44.751-.968.943-1.541a3.988 3.988 0 0 0-.052-2.681 15.473 15.473 0 0 1-.859-3.46 4.027 4.027 0 0 0-1.284-2.405A3.976 3.976 0 0 0 9.48 2.001H5.485A3.997 3.997 0 0 0 1.499 6.37c.4 4.101 1.82 8.324 4.288 12.136 2.003 3.217 4.864 6.164 8.397 8.408 3.424 2.263 7.579 3.816 12.115 4.308a3.989 3.989 0 0 0 3.208-1.166 3.99 3.99 0 0 0 1.16-2.828zm-2.667 0v4a1.334 1.334 0 0 1-1.328 1.344c-4.199-.448-7.948-1.855-11.017-3.883-3.237-2.057-5.812-4.716-7.603-7.592-2.263-3.493-3.54-7.308-3.899-10.984-.032-.357.085-.701.305-.965s.537-.44.904-.473l4.117-.007c.361-.004.676.125.916.341.227.205.384.488.431.811a18 18 0 0 0 1.009 4.033c.108.288.107.596.013.877a1.399 1.399 0 0 1-.323.527l-1.683 1.681a1.335 1.335 0 0 0-.216 1.601c2.112 3.713 5.119 6.609 8.508 8.504a1.336 1.336 0 0 0 1.593-.221l1.693-1.693c.221-.219.503-.343.797-.372.203-.02.413.007.612.08 1.363.508 2.76.848 4.045 1.005a1.3 1.3 0 0 1 .82.473c.196.241.308.549.301.909z"></path>
                            </svg>
                        </span>
                        <div class="phones">
                            <a href="tel:+34910005981" class="link">
                                <span class="text bold">+34910005981</span>
                            </a>
                        </div>
                    </div>
                    <p class="email-wrapper">
                        <a href="mailto:info@myinvestor.es" class="link flex row-left-cente">
                            <span class="icon">
                                <svg height="1em" width="1em" viewBox="0 0 32 32" role="presentation" style="min-width: 1em; max-width: 1em; min-height: 1em; max-height: 1em;">
                                    <path d="m4 11.228 11.236 7.865c.453.313 1.06.328 1.529 0L28 11.228v13.439c0 .363-.147.695-.393.94s-.577.393-.94.393H5.334c-.363 0-.695-.147-.94-.393s-.393-.577-.393-.94zM1.333 8.644v16.023c0 1.104.453 2.105 1.173 2.827s1.723 1.173 2.827 1.173h21.333c1.104 0 2.105-.453 2.827-1.173s1.173-1.723 1.173-2.827V8.643a3.994 3.994 0 0 0-1.173-2.803 3.997 3.997 0 0 0-2.827-1.173H5.333A4 4 0 0 0 2.506 5.84a3.99 3.99 0 0 0-1.173 2.804zm26.526-.572L16 16.372l-11.859-8.3a1.31 1.31 0 0 1 .251-.345c.247-.247.579-.393.941-.393h21.333c.363 0 .695.147.94.393.101.101.187.219.251.345z"></path>
                                </svg>
                            </span>
                            <span class="text black bold">info@myinvestor.es</span>
                        </a>
                    </p>
                </div>
                <div class="footer_section footer_section-rrss">
                    <ul class="rrss">
                        <li>
                            <a href="https://www.facebook.com/MyInvestorES/" title="facebook" rel="noopener noreferrer" target="_blank">
                                <span class="icon" style="font-size: 24px;">
                                    <svg height="1em" width="1em" viewBox="0 0 32 32" role="presentation" style="min-width: 1em; max-width: 1em; min-height: 1em; max-height: 1em;">
                                        <path d="M22.667 4.667v2.667H20c-.736 0-1.404.3-1.885.781s-.781 1.149-.781 1.885v4c0 .736.597 1.333 1.333 1.333h3.625L21.625 18h-2.959c-.736 0-1.333.597-1.333 1.333v9.333h-2.667v-9.333c0-.736-.597-1.333-1.333-1.333h-2.667v-2.667h2.667c.736 0 1.333-.597 1.333-1.333v-4c0-1.473.596-2.804 1.563-3.771S18.526 4.666 20 4.666zM24 2h-4c-2.209 0-4.211.897-5.657 2.343S12 7.791 12 10v2.667H9.333C8.597 12.667 8 13.264 8 14v5.333c0 .736.597 1.333 1.333 1.333H12v9.333c0 .736.597 1.333 1.333 1.333h5.333c.736 0 1.333-.597 1.333-1.333v-9.333h2.667c.621 0 1.144-.425 1.293-1.009l1.333-5.333a1.333 1.333 0 0 0-1.294-1.657h-4V10h4c.736 0 1.333-.597 1.333-1.333V3.334c0-.736-.597-1.333-1.333-1.333z"></path>
                                    </svg>
                                </span>
                            </a>
                        </li>
                        <li>
                            <a href="https://twitter.com/MyInvestorES" title="twitter" rel="noopener noreferrer" target="_blank">
                                <span class="icon" style="font-size: 24px;">
                                    <svg height="1em" width="1em" viewBox="0 0 32 32" role="presentation" style="min-width: 1em; max-width: 1em; min-height: 1em; max-height: 1em;">
                                        <path d="M29.901 2.924c1.007-.71 2.356.208 2.064 1.405a11.63 11.63 0 0 1-2.66 5.033c.02.216.03.433.031.652 0 15.813-15.261 23.936-28.648 16.499-1.228-.682-.703-2.554.701-2.498a14.196 14.196 0 0 0 6.499-1.29c-2.939-1.811-4.821-4.21-5.744-7.047-.953-2.929-.814-6.008-.019-8.931.241-.884.485-1.551.659-1.941a1.334 1.334 0 0 1 2.31-.225 12.881 12.881 0 0 0 9.575 5.442 7.307 7.307 0 0 1 12.177-5.495A13.192 13.192 0 0 0 29.9 2.925zM26.867 7.33a1.335 1.335 0 0 1-1.391-.402c-1.278-1.469-3.337-1.984-5.156-1.29s-3.011 2.45-2.985 4.415v1.333c0 .723-.576 1.314-1.299 1.333A15.547 15.547 0 0 1 4.54 8.07c-.527 2.273-.565 4.618.139 6.781.903 2.774 2.969 5.026 6.531 6.609a1.333 1.333 0 0 1 .207 2.322 16.848 16.848 0 0 1-4.84 2.262c10.239 2.694 20.091-4.103 20.091-16.027a4.695 4.695 0 0 0-.083-.861 1.333 1.333 0 0 1 .373-1.2c.297-.293.572-.605.824-.934a16.4 16.4 0 0 1-.916.307z"></path>
                                    </svg>
                                </span>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.youtube.com/channel/UCc9nsd1tjDdw32wLcM5OOWQ" title="youtube" rel="noopener noreferrer" target="_blank">
                                <span class="icon" style="font-size: 24px;">
                                    <svg height="1em" width="1em" viewBox="0 0 32 32" role="presentation" style="min-width: 1em; max-width: 1em; min-height: 1em; max-height: 1em;">
                                        <path d="M15.999 27.156h-.009c-.966-.007-9.502-.084-11.92-.739a4.946 4.946 0 0 1-3.48-3.478c-.633-2.376-.593-6.95-.588-7.315-.004-.364-.045-4.975.586-7.371l.002-.007c.45-1.671 1.815-3.045 3.476-3.501l.013-.003c2.391-.628 10.944-.705 11.912-.712h.017c.968.007 9.527.084 11.923.739a4.945 4.945 0 0 1 3.476 3.472c.657 2.397.596 7.019.589 7.409.004.384.043 4.917-.586 7.305a4.948 4.948 0 0 1-3.484 3.485l-.007.002c-2.391.628-10.944.705-11.911.712h-.009zM3.005 8.895c-.556 2.114-.503 6.667-.503 6.713v.033c-.017 1.263.042 4.919.503 6.651a2.441 2.441 0 0 0 1.716 1.711c1.784.483 8.737.635 11.278.652 2.548-.018 9.51-.166 11.282-.629a2.44 2.44 0 0 0 1.713-1.71c.462-1.757.52-5.396.503-6.651v-.04c.023-1.278-.022-4.977-.501-6.723l-.001-.005a2.44 2.44 0 0 0-1.717-1.714C25.511 6.7 18.547 6.548 16 6.531c-2.546.018-9.502.165-11.278.628a2.507 2.507 0 0 0-1.716 1.736zm9.808 11.761V10.531l8.75 5.063-8.75 5.062z"></path>
                                    </svg>
                                </span>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.linkedin.com/company/myinvestor/" title="linkedin" rel="noopener noreferrer" target="_blank">
                                <span class="icon" style="font-size: 24px;">
                                    <svg height="1em" width="1em" viewBox="0 0 32 32" role="presentation" style="min-width: 1em; max-width: 1em; min-height: 1em; max-height: 1em;">
                                        <path d="M10.5 25.568H6.49V12.62h4.01v12.948zm.401-17.073a2.35 2.35 0 1 0-4.7.002 2.35 2.35 0 0 0 4.7-.002zm14.609 9.949c0-3.476-.734-6.054-4.795-6.054-1.951 0-3.261.976-3.795 1.99h-.004v-1.761H13.02v12.948h3.896v-6.429c0-1.684.429-3.315 2.515-3.315 2.058 0 2.125 1.925 2.125 3.422v6.322h3.953v-7.123zm5.157 8.785V4.771a3.442 3.442 0 0 0-3.438-3.438H4.771a3.442 3.442 0 0 0-3.438 3.438v22.458a3.442 3.442 0 0 0 3.438 3.438h22.458a3.442 3.442 0 0 0 3.438-3.438zM27.229 3.625c.632 0 1.146.514 1.146 1.146v22.458c0 .632-.514 1.146-1.146 1.146H4.771a1.147 1.147 0 0 1-1.146-1.146V4.771c0-.632.514-1.146 1.146-1.146h22.458z"></path>
                                    </svg>
                                </span>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.instagram.com/myinvestores" title="instagram" rel="noopener noreferrer" target="_blank">
                                <span class="icon" style="font-size: 24px;">
                                    <svg height="1em" width="1em" viewBox="0 0 32 32" role="presentation" style="min-width: 1em; max-width: 1em; min-height: 1em; max-height: 1em;">
                                        <path d="M23.273 0A8.727 8.727 0 0 1 32 8.727v14.545a8.727 8.727 0 0 1-8.727 8.727H8.728a8.727 8.727 0 0 1-8.727-8.727V8.727A8.727 8.727 0 0 1 8.728 0h14.545zm0 2.909H8.728A5.818 5.818 0 0 0 2.91 8.727v14.545a5.818 5.818 0 0 0 5.818 5.818h14.545a5.818 5.818 0 0 0 5.818-5.818V8.727a5.818 5.818 0 0 0-5.818-5.818zM17.13 8.743a7.272 7.272 0 1 1-2.133 14.387A7.272 7.272 0 0 1 17.13 8.743zm-4.965 5.232a4.364 4.364 0 1 0 7.796 3.923 4.364 4.364 0 0 0-7.796-3.923z"></path>
                                    </svg>
                                </span>
                            </a>
                        </li>
                        <li>
                            <a href="https://t.me/myinvestornews" title="telegram" rel="noopener noreferrer" target="_blank">
                                <span class="icon" style="font-size: 24px;">
                                    <svg height="1em" width="1em" viewBox="0 0 32 32" role="presentation" style="min-width: 1em; max-width: 1em; min-height: 1em; max-height: 1em;">
                                        <path d="M31.506 2.741C31.115 2.263 30.53 2 29.857 2a3.24 3.24 0 0 0-1.151.229L1.619 12.569C.181 13.118-.012 13.941 0 14.383s.252 1.253 1.719 1.719l.026.008 5.619 1.608 3.039 8.689c.414 1.185 1.344 1.92 2.427 1.92.683 0 1.354-.286 1.942-.827l3.475-3.2 5.041 4.059.002.001.048.039a.127.127 0 0 1 .013.011c.56.435 1.172.664 1.769.664 1.167 0 2.097-.864 2.367-2.201l4.438-21.915c.178-.88.029-1.667-.421-2.217zM9.244 17.413l10.84-5.538-6.75 7.172a.933.933 0 0 0-.228.418l-1.302 5.272-2.561-7.324zm4.258 8.708c-.045.041-.09.078-.135.112l1.208-4.891 2.197 1.769-3.269 3.01zM30.089 4.585 25.651 26.5c-.043.21-.179.698-.53.698-.173 0-.391-.094-.614-.266l-5.712-4.599-.003-.002-3.399-2.737 9.761-10.372a.936.936 0 0 0-1.109-1.477L7.991 15.947l-5.695-1.629L29.375 3.981c.229-.087.388-.106.482-.106.057 0 .159.007.197.053.05.061.113.268.035.657z"></path>
                                    </svg>
                                </span>
                            </a>
                        </li>
                        <li>
                            <a href="https://open.spotify.com/show/1wtNYaVyWpEWKVPLrtraoZ?si=rWddTTY7Q2ebU6YJbFG9Rw" title="spotify" rel="noopener noreferrer" target="_blank">
                                <span class="icon" style="font-size: 24px;">
                                    <svg height="1em" width="1em" viewBox="0 0 32 32" role="presentation" style="min-width: 1em; max-width: 1em; min-height: 1em; max-height: 1em;">
                                        <path d="M15.273 1.455C6.851 1.455 0 8.306 0 16.727S6.851 32 15.273 32c8.421 0 15.273-6.852 15.273-15.273S23.695 1.455 15.273 1.455zm0 28.093c-7.069 0-12.821-5.751-12.821-12.821s5.751-12.82 12.821-12.82c7.069 0 12.82 5.751 12.82 12.82s-5.751 12.821-12.82 12.821zm7.129-5.219c-.281.392-.879.516-1.336.277-3.661-1.914-8.27-2.345-13.697-1.286-.522.102-1.044-.178-1.163-.625-.12-.448.208-.894.732-.995 5.939-1.161 11.033-.661 15.141 1.486.459.24.604.751.324 1.143zm1.789-3.846c-.338.599-1.056.787-1.603.419-4.019-2.698-10.147-3.48-14.901-1.903-.617.204-1.268-.177-1.455-.848-.187-.674.162-1.383.778-1.588 5.43-1.8 12.181-.929 16.797 2.169.548.369.722 1.153.384 1.751zm-.175-5.041c-4.94-2.817-13.086-3.077-17.802-1.701-.758.221-1.558-.19-1.788-.917s.198-1.496.955-1.717c5.414-1.577 14.412-1.272 20.099 1.97.681.388.904 1.233.501 1.886-.402.654-1.284.868-1.963.481l-.001-.001z"></path>
                                    </svg>
                                </span>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.ivoox.com/escuchar-myinvestor_nq_742061_1.html" title="ivoox" rel="noopener noreferrer" target="_blank">
                                <span class="icon" style="font-size: 24px;">
                                    <svg height="1em" width="1em" viewBox="0 0 32 32" role="presentation" style="min-width: 1em; max-width: 1em; min-height: 1em; max-height: 1em;">
                                        <path d="M17.275 29.161c0 1.853-1.356 1.205-2.368 1.303-1.138.111-1.915.022-1.865-1.373.13-3.494-.021-6.992.076-10.486.038-1.343-.259-2.036-1.986-1.814-.873.113-1.797-.06-2.675.037-1.574.17-2.07-.284-2.095-1.743-.026-1.594.436-2.15 2.271-1.969 1.495.147 3.023-.011 4.536.044 2.469.092 4.077 1.524 4.137 3.704.05 2.047.012 4.098.012 6.148a664.291 664.291 0 0 0-.042 6.15zm.056-19.501c-.141 1.396-.998 2.259-2.425 2.263-1.42.003-2.345-.825-2.446-2.24-.093-1.28 1.193-2.532 2.506-2.394 1.42.151 2.271.941 2.365 2.372V9.66zm-2.058-8.205C6.851 1.455 0 8.306 0 16.727S6.851 32 15.273 32c8.421 0 15.273-6.852 15.273-15.273S23.695 1.455 15.273 1.455zm0 28.093c-7.069 0-12.821-5.751-12.821-12.821s5.751-12.82 12.821-12.82c7.069 0 12.82 5.751 12.82 12.82s-5.751 12.821-12.82 12.821z"></path>
                                    </svg>
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- COPIRIGTH -->
        <div class="copyright-container">
            <div class="copyright-bar"><p class="copyright-bar_text">© 2025 MyInvestor. Todos los derechos reservados.</p></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'MYFooter',
    }
</script>

<style scoped>
.footer-container {
    background: var(--white);
    border-top: 2px solid var(--dark);
    font-size: 12px;
    line-height: 20px;
    width: 100%;
}
.footer-wrapper{
    max-width: 1140px; 
    padding: 42px 30px; 
    margin: 0 auto;
}
.footer-link_section {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
}
.footer_section{
    max-width: 25%;
}
.footer_section-rrss {
    max-width: 100%;
}
.title_section{
    font-weight: var(--font-weight-bold);
    font-size: 16px;
    line-height: 24px;
    margin-top: 0;
}
.text.bold {
    font-weight: var(--font-weight-bold);
}
.text.black {
    color: var(--black);
}
.menu {
    padding: 0;
    list-style: none;
}
.menu li:before {
    content: "";
    display: inline-block;
    width: 6px;
    height: 6px;
    margin-right: calc(var(--spacer)* .6);
    border-bottom: 1px solid var(--dark);
    border-right: 1px solid var(--dark);
    transform: rotate(-45deg) translate(1px);
}
a {
    color: var(--dark);
    text-decoration: none;
}
.phone-wrapper {
    display: flex;
    font-size: 16px;
}
.phones {
    display: flex;
    flex-direction: column;
}
.phones .text{
    margin-left: 10px;
}
.icon svg {
    fill: var(--dark);
}
.email-wrapper{
    font-size: 16px;
    font-size: 14px;
    line-height: 20px;
    margin-top: 40px;
}
.email-wrapper .text{
    margin-left: 10px;
    color: var(--primary);
}
.rrss {
    padding: 0;
    margin:0;
    text-align: right;
}
.rrss li {
    display: inline-block;
}
.rrss li+li{
    margin-left: var(--spacer);
}
li{
    padding-bottom: 6px;
}

/* COPIRIGTH */
.copyright-container {
    border-top: 2px solid var(--dark);
    width: 100%;
}
.copyright-bar {
    padding: 19px 0;
    max-width: 1140px;
    margin: 0 auto; 
}
.copyright-bar_text {
    font-size: 14px;
    margin: 0;
    line-height: 20px;
}

/* MOVIL */
@media (max-width: 768px) {
    .footer-container {
        background: var(--white);
        border-top: 2px solid var(--dark);
        width: 100%;
    }
    .footer-link_section{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 27px;
    }
    .footer_section{
        width: 100%;
        max-width: 100%;
    }
    .rrss {
        margin:0;
        padding: 0;
        text-align: center;
    }
    .copyright-bar {
        padding: 19px 15px;
    }
}
/* TABLET */
@media (min-width: 769px) and (max-width: 992px) {
    .footer-wrapper{
        width: 90%; 
        margin: 0 auto; 
    }
    .footer_section{
        width: 50%;
        max-width: 50%;
    }
    .footer-link_section {
        display: flex;
        flex-wrap: wrap;
        gap: 27px;
    }
    .footer-link_section > * {
        flex: 1 1 calc(50% - 27px); 
    }
    .copyright-bar {
        padding: 18px 0;
        width: 90%; 
        margin: 0 auto; 
    }
    .footer_section-rrss .rrss{
        text-align: left;
    }    
}
/* ESCRITORIO */
@media (min-width: 993px) {
    .footer-wrapper{
        padding: 40px 30px 20px;
    }
    .footer_section{
        width: 23.5%;
    }
    .footer_section-rrss{
        width: 29.5%;
    }
    .copyright-bar {
        padding: 25px 15px 25px;
    }
}


</style>